export const locale = {
    lang: 'ru',
    data: {
        'NAV': {
            'PAGES': 'Страницы',
            'DASHBOARD'        : {
                'TITLE': 'Рабочий стол',
                'BADGE': '555'
            },
            'CALENDAR': {
                'TITLE': 'Календарь',
                'BADGE': '111'
            },
            'LEADS': {
                'TITLE': 'Лиды',
                'BADGE': '222'
            },
            'LEADS_INDIVIDUAL': {
                'TITLE': 'Физ. лица',
                'BADGE': '50'
            },
            'LEADS_LEGAL': {
                'TITLE': 'Юр. лица',
                'BADGE': '50'
            },
            'CLIENTS': {
                'TITLE': 'Клиенты',
                'BADGE': '333'
            },
            'CLIENTS_INDIVIDUAL': {
                'TITLE': 'Физ. лица',
                'BADGE': '333'
            },
            'CLIENTS_LEGAL': {
                'TITLE': 'Юр. лица',
                'BADGE': '333'
            },
            'PROFILE': {
                'TITLE': 'Профиль',
                'BADGE': '444'
            },
            'ADDRESS_BOOK': {
                'TITLE': 'Адресная книга',
                'BADGE': '777'
            },
            'CUSTOM_FUNCTIONS': {
                'TITLE': 'Настройки',
            },
            'CUSTOM_SETTINGS': {
                'TITLE': 'Настройки внешнего вида',
            },
            'SETTINGS': {
                'TITLE': 'Общие настройки',
            },
            'MAIL': {
                'TITLE': 'Почта',
            },
            'TICKETS': {
                'TITLE': 'Тикеты',
            },
            'COPYTRADING': {
                'TITLE': 'Copytrading',
            },
            'PARTNERSHIP': {
                'TITLE': 'Партнерство',
            },
            'PAYMENTS_RATES': {
                'TITLE': 'Ставки по выплатам'
            },
            'IMPORT': {
                'TITLE': 'Импорт'
            },
            'EXPORT': {
                'TITLE': 'Экспорт'
            },
            'CONTACTS': {
                'TITLE': 'Контакты'
            },
            'EMAILS': {
                'TITLE': 'Emails',
                'BADGE': ''
            },
            'EMAIL_RULES': {
                'TITLE': 'Рассылка',
                'BADGE': ''
            },
            'EMAIL_TEMPLATES': {
                'TITLE': 'Шаблоны писем',
                'BADGE': ''
            },
            'USER_SELECTIONS': {
                'TITLE': 'Выборки пользователей',
                'BADGE': ''
            },
            'BULK_EMAILS': {
                'TITLE': 'Email рассылка',
                'BADGE': ''
            }
        },
        'DIALOGS': {
            'FROM': 'От',
            'TO': 'До',
            'SUBORDINATES': 'Сотрудники',
            'ALL_SUBORDINATES': 'Все сотрудники',
            'REPORT': 'Отчет',
            'TYPE': 'Тип',
            'CANCEL': 'Отмена',
            'GET_REPORT': 'Скачать отчет',
            'SEARCH': 'Поиск',
            'CLIENTS': 'Клиенты',
            'LEADS': 'Лиды',
            'IMPORT_LEADS': 'Импорт лидов',
            'ATTACH_BINARY_OR': 'Претащите файл сюда или',
            'SELECTING_ONE': 'выберите в проводнике',
            'UPLOAD': 'Загрузить',
            'SUCCESS_IMPORT': 'Импротировано {{success}} из {{total}}, {{exists}} уже существуют',
            'IMPORT_ERR': 'Неверный формат файла',
            'EXPORT_CLIENTS': 'Экспорт клиентов',
            'CLIENTS_NP': 'Физ. лица и ИП',
            'CLIENTS_LP': 'Юридические лица',
            'EXPORT_ERR': 'Нет клиентов для экспорта',
            'DOWNLOAD_TEMPLATE': 'Скачать шаблон импорта',
            'DOWNLOAD_COUTRY_LIST': 'Скачать список стран',
            'CONTACTS': 'Контакты'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/navigation/i18n/ru.ts